export enum IComponent {
  form = "1",
  table = "2",
}
